export default "__VITE_ASSET__Cz$ixGK___"